import React, { useState, useEffect } from "react";

const loadingMessages = {
  id: [
    "Sambil menunggu, istighfar dulu...",
    "Shalat dulu yuk sambil menunggu...",
    "Baca sholawat yuk...",
    "Perbanyak dzikir...",
    "Mohon doa restu...",
    "Mari kita persiapkan hati...",
    "Bismillahirrahmaanirrahiim...",
    "Alhamdulillah segala puji bagi Allah...",
    "Subhanallah wa bihamdihi...",
    "La haula wa quwwata illa billah...",
    "Hasbunallahu wa ni'mal wakil...",
    "Allahu Akbar...",
    "Yaa Hayyu Yaa Qayyumu Birahmatika Astaghitsu...",
    "Astagfirullah hal 'azim wa atubu ilaih...",
    "Shollallahu 'ala Muhammad...",
    "Barokallahu lakuma...",
    "Allahumma sholli 'ala Muhammad wa 'ala ali Muhammad...",
    "Jangan lupa bahagia...",
    "Hafalan itu butuh proses...",
    "Konsisten adalah kunci...",
    "Satu ayat demi satu ayat...",
  ],
  en: [
    "While waiting, let's say istighfar...",
    "How about we pray while waiting...",
    "Let's recite sholawat...",
    "Increase your dhikr...",
    "Please pray for success...",
    "Let's prepare our hearts...",
    "Bismillahirrahmaanirrahiim...",
    "Alhamdulillah, all praise to Allah...",
    "Subhanallah wa bihamdihi...",
    "La haula wa quwwata illa billah...",
    "Hasbunallahu wa ni'mal wakil...",
    "Allahu Akbar...",
    "Yaa Hayyu Yaa Qayyumu Birahmatika Astaghitsu...",
    "Astagfirullah hal 'azim wa atubu ilaih...",
    "Shollallahu 'ala Muhammad...",
    "Barokallahu lakuma...",
    "Allahumma sholli 'ala Muhammad wa 'ala ali Muhammad...",
    "Don't forget to be happy...",
    "Memorization takes time...",
    "Consistency is key...",
    "One verse at a time...",
  ]
};

const IslamicLoadingScreen = ({
  title = "Loading...",
  message,
  language = "id",
  size = "default",
  showBackground = true
}) => {
  const [randomMessage, setRandomMessage] = useState("");
  const [dotCount, setDotCount] = useState(0);

  useEffect(() => {
    const messages = loadingMessages[language] || loadingMessages.id;
    const randomIndex = Math.floor(Math.random() * messages.length);
    setRandomMessage(messages[randomIndex]);
  }, [language]);

  useEffect(() => {
    const interval = setInterval(() => {
      setDotCount(prev => (prev + 1) % 4);
    }, 500);
    return () => clearInterval(interval);
  }, []);

  const dots = ".".repeat(dotCount);

  const sizeClasses = {
    small: {
      spinner: "w-10 h-10 md:w-12 md:h-12",
      title: "text-sm md:text-base",
      message: "text-xs md:text-sm"
    },
    default: {
      spinner: "w-14 h-14 md:w-20 md:h-20",
      title: "text-base md:text-lg",
      message: "text-xs md:text-sm"
    },
    large: {
      spinner: "w-16 h-16 md:w-24 md:h-24",
      title: "text-lg md:text-xl",
      message: "text-sm md:text-base"
    }
  };

  const currentSize = sizeClasses[size] || sizeClasses.default;

  const content = (
    <div className="text-center space-y-3 md:space-y-4 px-4">
      {/* Islamic Pattern Background */}
      <div className="relative">
        <div className="absolute inset-0 bg-primary/5 rounded-full blur-3xl animate-pulse"></div>

        {/* Spinner */}
        <div className={`relative ${currentSize.spinner} border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto`}>
          <div className="absolute inset-2 border-2 border-primary/30 border-t-transparent rounded-full animate-spin" style={{ animationDirection: 'reverse' }}></div>
        </div>
      </div>

      {/* Title */}
      <p className={`${currentSize.title} font-semibold text-foreground`}>
        {title}{dots}
      </p>

      {/* Random Message */}
      <div className="space-y-2">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-primary/10 via-primary/5 to-primary/10 border border-primary/20">
          <span className="text-lg">✨</span>
          <p className={`${currentSize.message} text-primary font-medium text-center max-w-md`}>
            {message || randomMessage}
          </p>
          <span className="text-lg">✨</span>
        </div>
      </div>

      {/* Small Dhikr Counter */}
      <div className="flex items-center justify-center gap-4 text-xs text-muted-foreground">
        <div className="flex items-center gap-1">
          <span className="w-2 h-2 rounded-full bg-primary animate-pulse"></span>
          <span>{language === "id" ? "Sabar" : "Patience"}</span>
        </div>
        <div className="flex items-center gap-1">
          <span className="w-2 h-2 rounded-full bg-primary animate-pulse" style={{ animationDelay: '0.5s' }}></span>
          <span>{language === "id" ? "Istiqamah" : "Consistency"}</span>
        </div>
        <div className="flex items-center gap-1">
          <span className="w-2 h-2 rounded-full bg-primary animate-pulse" style={{ animationDelay: '1s' }}></span>
          <span>{language === "id" ? "Doa" : "Prayer"}</span>
        </div>
      </div>
    </div>
  );

  if (showBackground) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background via-background to-primary/5 relative overflow-hidden">
        {/* Decorative Elements */}
        <div className="absolute top-10 left-10 w-20 h-20 bg-primary/5 rounded-full blur-2xl"></div>
        <div className="absolute bottom-10 right-10 w-32 h-32 bg-primary/5 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 right-1/4 w-16 h-16 bg-primary/5 rounded-full blur-2xl"></div>

        {content}
      </div>
    );
  }

  return content;
};

export default IslamicLoadingScreen;
